import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon"]

  toggle() {
    const open = this.menuTarget.style.display === "block"
    this.menuTarget.style.display = open ? "none" : "block"
    this.openIconTarget.style.display = open ? "block" : "none"
    this.closeIconTarget.style.display = open ? "none" : "block"
  }

  close() {
    this.menuTarget.style.display = "none"
    this.openIconTarget.style.display = "block"
    this.closeIconTarget.style.display = "none"
  }
}
